import relationshipsOne from "./relationships-one"
import relationshipsTwo from "./relationships-two"

const steps = [...relationshipsOne, ...relationshipsTwo]

export default steps